import { Http } from "../axios/interceptors";

export const allCharges = async (param) =>
  Http("GET", `/RolesEmployees/GetByList?`, param);

export const getCharge = async (guid) =>
  Http("GET", `/RolesEmployees/Get?idRol=${guid}`);

export const createOrEditCharge = async (body, id = null) =>
  id
    ? Http("PUT", `/RolesEmployees/Update`, null, body)
    : Http("POST", "/RolesEmployees/Create", null, body);

export const deleteCharge = async (guid) =>
  Http("DELETE", `/RolesEmployees/Delete?idRol=${guid}`);
